import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=04e14d5b&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"
import style0 from "./Customer.vue?vue&type=style&index=0&id=04e14d5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e14d5b",
  null
  
)

export default component.exports